import PlayCanvasService from "../../../services/PlayCanvasService/PlayCanvasService";
import { Euler, readSelectedRotation, setRotation } from "./setRotation";
import { reselectSelected } from "./reselectSelected";

let isRegistered = false;
let isActive = false;
let locked: Euler | null = null;
let rafId: number | null = null;

function tick() {
  if (!isActive || !locked) return;
  setRotation(locked);
  rafId = requestAnimationFrame(tick);
}

function onMouseDown() {
  if (!isActive) return;
  if (!locked) locked = readSelectedRotation();
  if (!locked) return;
  if (rafId == null) rafId = requestAnimationFrame(tick);
}

function onMouseUp() {
  if (rafId != null) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
  // Some scenes finalize transform on mouseup; re-apply saved rotation
  if (isActive && locked) {
    requestAnimationFrame(() => setRotation(locked!));
    setTimeout(() => setRotation(locked!), 25);
    // Optionally trigger reselect to force gizmo/orientation sync
    setTimeout(() => {
      try { reselectSelected(); } catch {}
    }, 0);
  }
}

function ensureRegistered() {
  if (isRegistered) return;
  try {
    PlayCanvasService.addListenerMouseDown(onMouseDown);
    PlayCanvasService.addListenerMouseUp(onMouseUp);
    isRegistered = true;
  } catch {
    // ignore if service not ready yet
  }
}

export function startMoveRotationGuard() {
  ensureRegistered();
  // Capture rotation now; will also refresh on mousedown
  locked = readSelectedRotation();
  isActive = true;
}

export function stopMoveRotationGuard() {
  isActive = false;
  locked = null;
  onMouseUp();
}
